'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/intl-messageformat-parser/index.js
// module id = 1114
// module chunks = 7